import script from "./ContentDownloads.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentDownloads.vue?vue&type=script&setup=true&lang=ts"

import "./ContentDownloads.vue?vue&type=style&index=0&id=354655ce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-354655ce"]])

export default __exports__